import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { MakeFields } from './validation/fields';
import FormBase from '../../../../common/FormBase';
import Form from './Form';
import { makeInitialState } from '../../../../../helpers/FormHelper';
import { schema } from './validation/schema';

const NotReceived = ({ ...props }) => {
  const { mobile, motiveId, issueForm, typeId } = props;
  const [state, setState] = useState({});
  const [data, setData] = useState({});
  const [valid, setValid] = useState(false);
  const [validLength] = useState(10);
  const [showForm, setShowForm] = useState(true);

  const handleData = (data) => {
    setData(data);
  };

  const onState = (innerState) => {
    setState(innerState);
  };

  const handleValid = (validity) => {
    setValid(validity);
  };

  return (
    <React.Fragment>
      <FormBase
        pre={!showForm}
        issueForm={issueForm}
        mobile={mobile}
        form={
          <Form
            issueForm={issueForm}
            mobile={mobile}
            state={state}
            onData={handleData}
            valid={valid}
            motiveId={motiveId}
            fields={MakeFields()}
            setShowForm={setShowForm}
          />
        }
        data={data}
        fields={MakeFields()}
        formName="NotReceived"
        makeInitialState={makeInitialState}
        onState={onState}
        onValid={handleValid}
        schema={schema}
        motiveId={motiveId}
        typeId={typeId}
        validLength={validLength}
      />
    </React.Fragment>
  );
};

NotReceived.propTypes = {
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  issueForm: PropTypes.bool,
  typeId: PropTypes.string,
};

export default NotReceived;
